module.exports = "/assets/93515950fd43c363a52d4fbdd02f8898.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MN.png
// module id = 1620
// module chunks = 0